// src/socket.js
import { io } from "socket.io-client";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { ApiBaseUrl, ImgBaseUrl } from "./config";

const SOCKET_URL = ImgBaseUrl;

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false,
});

export const fetchSocketToken = async (userId) => {
  if (!userId) return null;
  try {
    const response = await axios.post(`${ApiBaseUrl}/chat/get_socket_token`, {
      id: String(userId),
      user_type: "customer",
    });
    if (
      response.data &&
      response.data.ResponseCode === 200 &&
      response.data.socket_token
    ) {
      const token = response.data.socket_token;
      secureLocalStorage.setItem("socket_token", token);
      return token;
    }
  } catch (error) {
    console.error("Failed to fetch socket token:", error);
  }
  return null;
};

export const connectSocket = async (userId) => {
  if (socket.connected) {
    console.log("Socket already connected.");
    return;
  }
  let token = secureLocalStorage.getItem("socket_token");
  if (!token && userId) {
    token = await fetchSocketToken(userId);
  }
  if (token) {
    socket.auth = { token };
    socket.connect();
    console.log("Socket connecting with token...");
  } else {
    console.warn("No socket token available. Socket not connected.");
  }
};

export const disconnectSocket = () => {
  if (socket.connected || socket.connecting) {
    socket.disconnect();
    console.log("Socket disconnected.");
  }
};

socket.on("connect_error", async (err) => {
  console.error("Socket connection error:", err.message);
  if (
    err.message === "Unauthorized" ||
    err.message === "unauthorized" ||
    (err.data && err.data.message === "Unauthorized")
  ) {
    console.log("Unauthorized socket connection, trying to refresh token...");
    const userId = secureLocalStorage.getItem("Userid");
    if (userId) {
      const newToken = await fetchSocketToken(userId);
      if (newToken) {
        socket.auth = { token: newToken };
        socket.connect();
      }
    }
  }
});
